import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'nullToEmptyString', pure: false})
export class NullToEmptyStringPipe implements PipeTransform {
  transform(input:any):string {
    if(input == 'null' || input == 'undefined' || !input) input = '';
    return input;
  }
}